<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Run a report</cll-dialog-title>
    </cll-dialog-header>
    <div class="dialog-container">    
        <div class="dialog-detail">
            <div class="dialog-container-header">
                <cll-icon type="outlined" [size]="24">filter_list</cll-icon>
                <span class="dialog-container-header-text">Filters</span>
            </div>
            <div class="grid-columns-2">
                <div>
                    <cll-form-field label="From">
                        <input cllFormInput  type="date" [(ngModel)]="startDate">
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="To">
                        <input cllFormInput  type="date" [(ngModel)]="endDate">
                    </cll-form-field>
                </div>
            </div>
            <hr class="add-new-divider">
            <div class="dialog-container-header">
                <cll-icon type="outlined" [size]="24">assignment</cll-icon>
                <span class="dialog-container-header-text">Reports</span>
            </div>
            <div class="reports">
                <cll-radio-group-input appearance="outlined" [options]="reportOptions"
                 class="package-open-margin" 
                 [(ngModel)]="selectedReport"/>
            </div>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>
        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                cllDialogClose
                iconPosition="after"
                [disabled]="startDate === '' || endDate === '' || selectedReport === ''"
                (click)="runReport()" >
            Run
            <cll-icon type="outlined">chevron_right</cll-icon>
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
